// app/javascript/channels/consumer.js
import { createConsumer } from "@rails/actioncable"

// Dynamically determine the WebSocket URL based on the current location
const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
const host = window.location.host; // Includes subdomain and port if any
const actionCableUrl = `${protocol}${host}/cable`;

// Create the Action Cable consumer with the dynamically set URL
export default createConsumer(actionCableUrl)